import { SubscriptionPlan } from "../../../../../types/subscription/subscription-plan";
import { TableBody } from "../../../../../_components/molecule/listview.component";
import Label from "../../../../../_components/typography/label.typography";
import { MemberTableRowShimmer } from "../../../invited-users-list";
import { Status } from "../../subscriptions-list/subscriptions-page";
import { ActiveSubscriptionMember } from "../subscription-detail-component";
import {
  ActiveMembersListTile,
  LogsListTile,
} from "./active-subscription-member-tile";

function TableHeader({ headers }: { headers: string[] }) {
  return (
    <thead className="border text-right text-xs text-secondary-foreground">
      <tr>
        {headers.map((header) => (
          <th key={header} className="p-1 py-3 text-left md:px-4">
            <Label variant="t1">{header}</Label>
          </th>
        ))}
      </tr>
    </thead>
  );
}

interface LogsListTileProps {
  status: Status;
  communityId: string;
  subscription: SubscriptionPlan;
  logs: Array<ActiveSubscriptionMember> | undefined;
}

/**
 * Displays the subscription logs.
 */
export function LogsDetailList({
  subscription,
  logs,
  communityId,
}: LogsListTileProps) {
  const headers = ["Invoice", "Member", "State", "Country", "Payment on"];

  return (
    <div className="mx-4">
      <table className="w-full table-auto rounded border bg-card text-sm text-secondary-foreground/80">
        <TableHeader headers={headers} />
        <tbody>
          <TableBody
            items={logs}
            renderItem={(sub: ActiveSubscriptionMember, index: number) => (
              <LogsListTile
                subscription={subscription}
                key={index}
                plan={sub}
                communityId={communityId}
                onPlanUpdate={() => {}}
              />
            )}
            noItemsElement={
              <tr>
                <td colSpan={6} className="h-96 px-4 py-3 text-center">
                  <Label variant="s1">No Logs Available</Label>
                </td>
              </tr>
            }
            placeholder={[...Array(10)].map((_, index) => (
              <MemberTableRowShimmer key={index} />
            ))}
          />
        </tbody>
      </table>
    </div>
  );
}

interface IActiveMembersListTileProps {
  status: Status;
  subscription: SubscriptionPlan;
  communityId: string;
  activeMembers: Array<ActiveSubscriptionMember> | undefined;
  onPlanUpdate: (plan: ActiveSubscriptionMember) => void;
}
/**
 * Active Members in Subscription
 */
export function ActiveSubscriptionMembers({
  activeMembers,
  subscription,
  status,
  communityId,
  onPlanUpdate,
}: IActiveMembersListTileProps) {
  const headers = [
    "Invoice",
    "Member",
    "State",
    "Country",
    "Started on",
    "Next renewal on",
  ];

  return (
    <div className="ActiveSubscriptionMembers mx-4 rounded">
      <table className="theme-default-border w-full table-auto rounded border bg-card text-sm text-secondary-foreground/80">
        <TableHeader headers={headers} />
        <tbody>
          <TableBody
            items={activeMembers}
            loading={status === "loading"}
            renderItem={(sub: any, index: number) => (
              <ActiveMembersListTile
                subscription={subscription}
                key={index}
                plan={sub}
                communityId={communityId}
                onPlanUpdate={onPlanUpdate}
              />
            )}
            noItemsElement={
              <tr>
                <td colSpan={6} className="h-96 text-center">
                  <Label variant="s1">No Active members</Label>
                </td>
              </tr>
            }
            placeholder={[...Array(10)].map((_, index) => (
              <MemberTableRowShimmer key={index} />
            ))}
          />
        </tbody>
      </table>
    </div>
  );
}
